import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';
import { FaSave, FaUserAlt, FaUserAltSlash, FaAngleLeft, FaKey, FaRegEnvelope } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import Pagination from  '../../../components/Pagination/Pagination';
import { API } from 'aws-amplify';
import { MdClear } from 'react-icons/md';

import { useToasts } from 'react-toast-notifications';


const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const UserDetail = (props) => {
    const [isLoading, setIsLoading] = useState(false);
	const [contractorList, setContractorList] = useState([]);
    const [user, setUser] = useState({  name: '',
                                        username:'',
                                        admin:'',
                                        contractor:'',
                                        status:'',
                                        confirmed: '',
                                        enabled: '',
                                        assets: [],
                                        settings: [],

                                    });
    const { addToast } = useToasts();
    const [assets, setAssets] = useState([]);
    const [assetList, setAssetList] = useState([]);
    const [assetUser, setAssetUser] = useState([]);
    // const [viewUser, setViewUser] = useState([]);
    const [userSettings, setUserSettings] = useState({format_date: 'DD-MM-YYYY', profile: ''});
    const [locationList, setLocationList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [asset, setAsset] = useState('');
	const [location, setLocation] = useState('');
	const [country, setCountry] = useState('');
	// const [permissions, setPermissions] = useState([]);
	const [profiles, setProfiles] = useState([]);
	// const [profile, setProfile] = useState();
	const [selProfile, setSelProfile] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [chkAll, setChkAll] = useState(false);
	const [itemsPerPage] = useState(10);
    // const [views, setViews] = useState([
    //             {id: "queue_det", name: "Queue Detector"},
    //             {id: "vehicle_det", name: "Vehicle Detector"},
    //             {id: "vehicle_det_trend", name: "Vehicle Detector Trend"},
    //             {id: "queue_det_trend", name: "Queue Detector Trend"},
    //             {id: "vehicle_det_annual_trend", name: "Vehicle Detector Annual Trend" }
    //         ]);


    // Load users
	useEffect(()=>{
        const fetchUser = async () => {
            setIsLoading(true);

            API.get('users','/' + props.match.params.id, params)
            .then(res => {

                let user ={}
                user.username = res.Username;
                res.UserAttributes.forEach((e) => {
                    if (e.Name === 'name') user.name = e.Value;
                    if (e.Name === 'custom:administrator') user.admin = e.Value;
                    if (e.Name === 'custom:contractor') user.contractor = e.Value;
                })
                user.status = res.UserStatus;
                user.enabled = res.Enabled;

                if (user.status === 'CONFIRMED')
                    user.confirmed = "checked";
                else
                    user.confirmed = "";

                setUser(user);
            });

            //Get user asset list
            let user_assets = []
            user_assets = await API.get('user_assets','/' + props.match.params.id, params)
            if (user_assets){
                if (user_assets.assets)
                    setAssetUser(user_assets.assets);
                // if (user_assets.views)
                //     setViewUser(user_assets.views);
                if (user_assets.settings)
                    setUserSettings(user_assets.settings);

            }else{
                user_assets = []
                user_assets.assets = []
                // user_assets.views = []
                user_assets.settings = []
            }

            if (user_assets.settings && user_assets.settings.profile === undefined) setUserSettings({...userSettings, profile: 'General'})

            let assets = []
            //Get all assets (if user == SubAdmin then all assets == SubAdmin assets)
            assets = await API.get('asset','/', params)
            if (props.user.profile === 'SubAdmin'){
                const subAdm_assets = await API.get('user_assets','/' + props.user.username, params)
                if (subAdm_assets && subAdm_assets.assets)
                    assets = assets.filter(item => subAdm_assets.assets.includes(item.id) && item.status === 'active')
            }
            assets.sort((a, b) => (a.location > b.location) ? 1 : -1)    

            //map and merge assets and user asset list
            let merge = [...assets]
            if (user_assets.assets)
                merge = assets.map(item => (user_assets.assets.find(i => i === item.id) ? {...item, checked:true} : {...item, checked:false}))
            else
                merge = assets.map(item => ({ ...item,  checked: false }))

            //map and merge views and user view list
            // let mergeViews = [...views]
            // if (user_assets.views)
            //     mergeViews = views.map(item => (user_assets.views.find(i => i === item.id) ? {...item, checked:true} : {...item, checked:false}))
            // else
            //     mergeViews = views.map(item => ({ ...item,  checked: false }))

            merge.sort((a, b) => (a.checked < b.checked) ? 1 : -1)    

            setAssetList(merge);
            setAssets(merge);
            // setViews(mergeViews);

            setIsLoading(false);
		}
        if (props.user.profile)
            fetchUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.id, props.user]);

    // Load location
	// useEffect(()=>{
	// 	const fetchLocation = async () => {
    //         const loc = [...new Set(assets.map(item => item.location))];
	// 		setLocationList(loc);
	// 	}
    //     fetchLocation();
    // }, [assets]);

    // load countries
    useEffect(()=>{
		const fetchCountry = async () => {
            let loc = [...new Set(assets.map(item => item.country))];
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)

            if (loc.length === 1)
                setCountry(loc[0]);

			setCountryList(loc);
		}
        fetchCountry();

    }, [assets]);

    // Load location
	useEffect(()=>{
		const fetchLocation = async () => {
            let loc=[]
            if (country){
                loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
            }else{
                loc = [...new Set(assets.map(item => item.location))];
            }
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)
			setLocationList(loc);
		}
        fetchLocation();
    }, [assets, country]);

    // Load contractors
	useEffect(()=>{
		const fetchContractors = async () => {

                const contractors = await API.get('company','/name', params)
                contractors.values.sort((a, b) => (a > b) ? 1 : -1)
                let list = []
                for (let i = 0; i < contractors.values.length; i++) {
                    list.push(<option key={contractors.values[i]} value={contractors.values[i]}>{contractors.values[i]}</option>)
                }

                setContractorList(list);

            }
            fetchContractors();
    }, []);

    // Load permissions
    useEffect(()=>{
		const fetchPermissions = async () => {

            const perm = await API.get('permissions','/types', params)
            const permission = await API.get('custom_permission_list','/', params)

            let ls = []
            for (let i = 0; i < permission.length; i++) {
                const { profile_name, ...newObj } = permission[i].customProfile;
                ls.push([permission[i].customProfile.profile_name, newObj])
            }

            // const prof = Object.keys(perm.values)
            const entries = Object.entries(ls)

            setProfiles(ls);

            }
            fetchPermissions();
    }, []);

    // Load permissions
    useEffect(()=>{
        const selectProfile = async () => {

            if (userSettings && userSettings.profile){
                const prof = profiles.find(i => i[0]===userSettings.profile)
                if (prof)
                    setSelProfile(prof[1]);

                // const entries = Object.entries(prof)

                // const entries = Object.keys(prof).map((key) => {
                //     // [key, prof[key]]
                //     // console.log(key)
                //     // console.log(prof[key])

                //     const entry = prof[key]

                //     Object.keys(entry).map((key) => {
                //         console.log(key);
                //         // console.log(entry[key].value);
                //         // console.log(entry[key].label);
                //     })

                // })
            }

        }

        selectProfile();

    }, [profiles, userSettings]);

	const validateForm = () => {
		return (
            user.username.length > 0 &&
			user.name.length > 0 &&
			user.contractor.length > 0
		);
	}

	const handleSubmit = async event => {
		event.preventDefault();
		setIsLoading(true);

		try {
            // clean assets list
            const assetList = assets.map(item => item.id).filter(item => assetUser.includes(item))
            
            // Update user permissions
            API.post('user_assets', '/', {
                body: {
                    id: user.username,
                    assets: assetList,
                    // views: viewUser,
                    settings: userSettings
                },
                headers: {
                 'x-api-key': process.env.REACT_APP_API_KEY,
                 'Accept': 'application/json',
                 'Content-Type': 'application/json',
                 },
            })
            .then(response => {
                // console.log(response)
                // addToast('Asset Saved', { appearance: 'success' });
            }).catch(error => {
                // console.log(error)
                addToast('Error Saving User Permissions', { appearance: 'error' });
            });

            // Update user details
            API.post('user_update', '/' + user.username, {
                body: {
                    name: user.name,
                    admin: user.admin,
                    contractor: user.contractor,
                },
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            })
            .then(res => {
                addToast('User Saved', { appearance: 'success' });
                props.history.push('/users/');
            }).catch(error => {
                // console.log(error)
                addToast('Error Saving User: ' + error, { appearance: 'error' });
            });

		} catch (e) {
            addToast(e.message, { appearance: 'error' });

		}

		setIsLoading(false);
	};

    const handleDisableUser = () => {
		try {
            API.get('user_disable','/' + props.match.params.id, params)
            .then(res => {
                setUser({...user, enabled: false})
            });
		} catch (e) {
            addToast(e.message, { appearance: 'error' });

		}
    };

    const handleEnableUser = () => {
		try {
            API.get('user_enable','/' + props.match.params.id, params)
            .then(res => {
                setUser({...user, enabled: true})
            });
		} catch (e) {
            addToast(e.message, { appearance: 'error' });

		}
    };

    const handleConfirmUser = () => {
		try {
            API.get('user_confirm','/' + props.match.params.id, params)
            .then(res => {
                setUser({...user, status: 'CONFIRMED'})
            });
		} catch (e) {
            addToast(e.message, { appearance: 'error' });

		}
    };

    useEffect(() => {

        const handleSearch = () => {
            let results = assets;
            // asset
            if (asset){
                results = results.filter(results =>
                    results.name && results.name.toLowerCase().includes(asset.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            setAssetList(results);
            paginate(1);
        }

		handleSearch();
        }, [location, country, assets, asset]);

    const handleResetPassword = () => {
		try {
            API.get('user_reset_pwd','/' + props.match.params.id, params)
            .then(res => {
                // setUser({...user, status: 'CONFIRMED'})
                addToast('Password Reset Code sent', { appearance: 'success' });
            });
		} catch (e) {
            addToast(e.message, { appearance: 'error' });

		}
    }

    const handleCheckList = (e) => {
        // update user list
        if (e.target.checked){
            setAssetUser([...assetUser, e.target.id])
            // console.log("add " + e.target.id)
        }else{
            const arr = assetUser.filter(item => item !== e.target.id)
            setAssetUser(arr)
            // console.log("remove " + e.target.id)
        }

        // Update target
        const target  = assetList.find(i => i.id === e.target.id)
        target.checked = e.target.checked

    }

    // check all assets 
    const handleCheckAll = () => {
        // update user list
        // console.log(chkAll)
        const arrAdd = []
        const arrRem = []
        assetList.map(item => {
            item.checked =  !chkAll;
            if (item.checked){
                // console.log("check >> ", item.id)
                arrAdd.push(item.id)
            }else{
                // console.log("uncheck >> ", item.id)
                arrRem.push(item.id)
            }
            return(assetUser)
        })

        if (arrAdd.length>0){
            setAssetUser([...new Set(assetUser.concat(arrAdd))])
        }
        if (arrRem.length>0){
            setAssetUser(assetUser.filter(item => !arrRem.includes(item)))
        }

    }

    const handleClearSearch = () =>{
		setLocation('');
        setCountry('');
        setAsset('');
	}

    // const handleViewCheckList = (e) => {
    //     // update user list
    //     if (e.target.checked){
    //         setViewUser([...viewUser, e.target.id])
    //         // console.log("add " + e.target.id)
    //     }else{
    //         const arr = viewUser.filter(item => item !== e.target.id)
    //         setViewUser(arr)
    //         // console.log("remove " + e.target.id)
    //     }

    //     // Update target
    //     const target  = views.find(i => i.id === e.target.id)
    //     target.checked = e.target.checked
    // }

    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItemList = assetList.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = pageNumber => setCurrentPage(pageNumber);
    

	return (
        !isLoading ? (
		<div className="DeviceList">
        <div className="col-md-12">
        <form key="form" onSubmit={handleSubmit}>
            <div className="row header">
                <div className="col-md-4">Edit User</div>
                <div className="col-md-8 d-flex justify-content-end">
                    <Button variant="secondary" className="mr-1 text-nowrap" onClick={()=>{props.history.goBack()}}>
                        Back &nbsp;
                        <FaAngleLeft />
                    </Button>
                    {(props.viewPermissions.find(i => i === 'edit_users'))?
                    <Button variant="success" className="mr-1 text-nowrap" type="submit" disabled={!validateForm()} >
                        Save &nbsp;
                        <FaSave />
                    </Button>
                    :''}
                    {(user.status !== 'CONFIRMED' && user.enabled) ?
                    <Button variant="info" className="mr-1" type="button" onClick={()=>handleConfirmUser()}>
                        Confirm Email &nbsp;
                        <FaRegEnvelope />
                    </Button>
                     :''}
                    {user.enabled ? (
                    <Button variant="danger" className="mr-1" type="button" onClick={()=>handleDisableUser()}>
                        Disable User &nbsp;
                        <FaUserAltSlash />
                    </Button>  ):(
                    <Button variant="warning" className="mr-1" type="button" onClick={()=>handleEnableUser()}>
                        Enable User &nbsp;
                        <FaUserAlt />
                    </Button>
                    )}
                    <Button variant="info" className="mr-1" type="button" onClick={()=>handleResetPassword()}>
                        Reset Password &nbsp;
                        <FaKey />
                    </Button>

                </div>
            </div>
            <div className="row div-content">
                <div className='col-md-12'>
                    <Tabs defaultActiveKey="details" transition={false} id="user_det">
                        <Tab eventKey="details" title="Details">
                            <TabContent className="p-3" >
                            <div className='row'>
                                <div className="col-md-6">
                                    <Form.Group controlId="username" >
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="input" value={user.username} disabled />
                                    </Form.Group>
                                    <Form.Group controlId="name" >
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control autoFocus type="input" value={user.name} onChange={(e) => setUser({...user, name: e.target.value})} />
                                    </Form.Group>
                                    <Form.Group controlId="contractor" >
                                        <Form.Label>Group</Form.Label>
                                        <Form.Control as="select" value={user.contractor}
                                            onChange={(e) => setUser({...user, contractor: e.target.value})}
                                            disabled={props.user.administrator==='false'}>
                                            <option key="cont1" value=""></option>
                                            {contractorList}
                                        </Form.Control>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group controlId="administrator" >
                                        <Form.Label>System Administrator</Form.Label>
                                        <Form.Control as="select" value={user.admin} onChange={(e) => setUser({...user, admin: e.target.value})} disabled={props.user.administrator==='false'} >
                                            <option key="adm1" value="false">No</option>
                                            <option key="adm2" value="true">Yes</option>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group controlId="format_date" >
                                        <Form.Label>Format Date</Form.Label>
                                        <Form.Control as="select" value={userSettings.format_date} onChange={(e) => setUserSettings({...userSettings, format_date: e.target.value})}>
                                            <option key="fd1" value="DD-MM-YYYY">DD-MM-YYYY</option>
                                            <option key="fd2" value="MM-DD-YYYY">MM-DD-YYYY</option>
                                        </Form.Control>
                                    </Form.Group>
                                </div>
                            </div>
                            </TabContent>
                        </Tab>
                        <Tab eventKey="asset_views" title="Assets">
                            <TabContent className="p-3" >
                                <div className="col-md-12">
                                    <div className="row px-3">
                                        {/* <div>
                                            <h2 className="text-header">Assets Permission</h2>
                                        </div> */}
                                        <div className='pl-2'>
                                        <Form.Group controlId="site_ref">
                                            <Form.Control
                                                as="input"
                                                value={asset}
                                                onChange={e => {setAsset(e.target.value)}}
                                                placeholder="Asset"
                                                type="text" />
                                            </Form.Group>
                                        </div>
                                        <div className="pl-2">
                                            <Form.Group controlId="country">
                                            <Form.Control
                                                as="select"
                                                value={country}
                                                onChange={e => {setCountry(e.target.value)}}>
                                                    <option value="">Country</option>
                                                    {countryList.map((item, i) =>
                                                        <option key={`country`+i} value={item}>{item}</option>
                                                        )}

                                            </Form.Control>
                                            </Form.Group>
                                        </div>
                                        <div className="pl-2">
                                            <Form.Group controlId="location">
                                                <Form.Control
                                                    as="select"
                                                    value={location}
                                                    onChange={e => {setLocation(e.target.value)}}>
                                                        <option key="loc_0" value="">Location</option>
                                                        {locationList.map((item, i) =>
                                                            <option key={`loc`+i} value={item}>{item}</option>
                                                            )}
                                                </Form.Control>
                                            </Form.Group>
                                        </div>
                                        <div className="col-2">
                                            <Button className='close-button' variant="danger" size="sm" onClick={handleClearSearch}>
                                                <MdClear />
                                            </Button>
                                        </div>
                                    </div>

                                    {(!isLoading) ? (
                                        (currentItemList.length === 0) ? (
                                            <div className="col-md-12 p-4 text-center text-secondary">No records found</div>
                                        ):(
                                        <div>
                                        <Table size="sm" responsive hover variant="light">
                                        <thead>
                                            <tr>
                                            <th className='border-bottom'>
                                            <Form.Check
                                                inline
                                                type="checkbox"
                                                id="chkAll"
                                                checked={chkAll}
                                                onChange={(e)=>{
                                                    setChkAll(e.target.checked);
                                                    handleCheckAll();
                                                 }}
                                                />
                                            </th>
                                            <th className='border-bottom'>Asset</th>
                                            <th className='border-bottom'>Country</th>
                                            <th className='border-bottom'>Location</th>
                                            <th className='border-bottom'>Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {currentItemList.map((item, i) => (
                                        <tr key={"asset"+i} className="table-tr">
                                            <td className='border-bottom'>
                                            <Form.Check
                                                inline
                                                type="checkbox"
                                                id={item.id}
                                                checked={item.checked}
                                                onChange={handleCheckList}
                                                />
                                            </td>
                                            <td className='border-bottom'>{ item.name || item.id + ' - unassigned'}</td>
                                            <td className='border-bottom'>{ item.country }</td>
                                            <td className='border-bottom'>{ item.location }</td>
                                            <td className='border-bottom'>{ item.address }</td>
                                        </tr>
                                        ))}
                                        </tbody>
                                        </Table>
                                        <Pagination
                                            sizePerPage={itemsPerPage}
                                            currentPage={currentPage}
                                            totalSize={assetList.length}
                                            changeCurrentPage={paginate}
                                            theme="bootstrap"
                                        />

                                    </div>

                                    )):(

                                        <div className="col-md-12">
                                        <Spinner animation="grow" size="sm" role="status" variant="warning" />
                                        <span className="text-dark">  Loading...</span>
                                        </div>
                                    )}
                                </div>
                            </TabContent>
                        </Tab>
                        {/* <Tab eventKey="reports_views" title="Reports">
                            <TabContent className="p-3" >
                                <div className="col-md-12">
                                    <div className="row px-3">
                                        <div className='col-md-12'>
                                            <h2 className="text-header">Reports Permission</h2>
                                        </div>
                                        <div className="col-md-4 pt-4 justify-content-end">
                                            <Table size="sm" responsive  hover variant="light">
                                            <thead>
                                                <tr>
                                                <th></th>
                                                <th>Reports</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {views.map((item, i) => (
                                            <tr key={"view"+i}>
                                                <td className='border-bottom'>
                                                <Form.Check
                                                    inline
                                                    type="checkbox"
                                                    id={item.id}
                                                    checked={item.checked}
                                                    onChange={handleViewCheckList}
                                                    />
                                                </td>
                                                <td className='border-bottom'>{item.name}</td>
                                            </tr>
                                            ))}
                                            </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </TabContent>
                        </Tab> */}
                        <Tab eventKey="permissions" title="Permissions">
                            <TabContent className="p-3">
                                <div className="col-md-12">
                                    {/* <div className='col-md-12'>
                                        <h2 className="text-header">User Permissions</h2>
                                    </div> */}
                                    <div className="row px-3">
                                        <div className="pl-2">
                                            <Form.Group controlId="profile">
                                            <Form.Label>Profile</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={userSettings.profile}
                                                onChange={e => {setUserSettings({...userSettings, profile: e.target.value})}}
                                                disabled={props.user.administrator==='false'}>
                                                    <option key={`profile0`}></option>
                                                    {profiles.map((item, i) =>
                                                        <option key={`profile`+i} value={item[0]}>{item[0]}</option>
                                                        )}
                                            </Form.Control>
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">{
                                            Object.keys(selProfile).map((key,i) =>
                                                <div key={`k`+i} className="col-md-3">
                                                    <h4>{key}</h4>
                                                <div>
                                                {
                                                Object.keys(selProfile[key]).map((key1,j) =>
                                                    <div key={`div`+key1}>
                                                        <Form.Check
                                                        // inline
                                                        type="checkbox"
                                                        id={key1}
                                                        checked={selProfile[key][key1].checked}
                                                        // onChange={handleCheckList}
                                                        label={selProfile[key][key1].label}
                                                        disabled={true}
                                                        />
                                                    </div>
                                                )
                                                }
                                                </div>
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabContent>
                        </Tab>
                    </Tabs>
                </div>

			</div>
            </form>
            </div>
        </div>
        ) : ''
	);

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        viewPermissions: state.auth.viewPermissions,
    };
  };

export default connect(mapStateToProps)(UserDetail);
